import { Injectable, Sanitizer, SecurityContext } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HelpDocumentData, HelpPage } from './help-types';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class HelpService {
  readonly getDocumentsUrl: string = '/helpSystem/getDocuments.json';

  readonly saveDocumentUrl: string = '/helpSystem/saveDocument.json';

  private _selectedPage: HelpPage = null;

  public get selectedPage(): HelpPage {
    return this._selectedPage;
  }

  public set selectedPage(page: HelpPage) {
    this._selectedPage = page;
  }

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }
  
  getDocuments() {
    return this.http.get<HelpDocumentData[]>(this.getDocumentsUrl);
  }

  saveDocument(document: HelpDocumentData) {
    return this.http.post<HelpDocumentData>(this.saveDocumentUrl, {document: document});
  }

  get getSelectedPageContent() {
    return this.sanitizer.bypassSecurityTrustHtml(this._selectedPage.content);
  }
}
